import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'v2m-functions',
  templateUrl: './functions.component.html',
  styleUrls: ['./functions.component.scss']
})
export class FunctionsComponent implements OnInit {
  images = ['url(assets/teaser_funktionen.jpg)'];

  constructor(private modalService: ModalService, private seo: SeoService) {}

  ngOnInit() {
    this.seo.updateTitle('video2manual - Funktionen');
    this.seo.updateKeywords(
      'Standbilder,Schnappschuss,Verzeichnisse importieren,Rückgängig'
    );
  }

  openModal(id: string) {
    this.modalService.open(id);
  }

  closeModal(id: string) {
    this.modalService.close(id);
  }
}
